import React from "react";
import firaImage from "../images/fira.png";
import cliffsImage from "../images/cliffs.png";
import sunsetoiaImage from "../images/sunsetoia.png";

function TodoImages() {
	return (
		<>
			<img
				src={firaImage}
				alt="Three Bells of Fira"
			/>
			<img
				src={cliffsImage}
				alt="Cliff View"
			/>
			<img
				src={sunsetoiaImage}
				alt="Sunset at Oia"
			/>
		</>
	);
}

export default TodoImages;
